$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';

import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     /*-------- Swiper Clients ---------*/
     var swiper = new Swiper(".swiper__clients", {
        modules: [Autoplay],
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
        loop: true,
        watchSlidesProgress: true,
        slidesPerView: 5,
      });

     /*-------- Swiper Service ---------*/

     var swiper = new Swiper(".Swiper__service", {
        modules: [Navigation, Autoplay, Pagination],
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            576: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
          },
      });


      var swiperActu = new Swiper(".Swiper__actualite", {
        modules: [Navigation, Autoplay, Pagination],
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 50,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

      });
      
      if($(".Swiper__actualite .swiper-slide").length == 1) {
       
        $('.swiper-button-prev').addClass( "disabled" );
        $('.swiper-button-next').addClass( "disabled" );
        
    }




    /*-------- MASONRY ---------*/
    
    const grid = document.querySelector('.masonry');
    imagesLoaded(grid, function() {
        const msnry = new Masonry(grid, {
            itemSelector: '.masonry-item',
            columnWidth: '.masonry-sizer',
        percentPosition: true,
        horizontalOrder: true
        });
    });

   
    
});

    
    

